const MIN_EMAIL_LEN = 5; // x@y.z
// See: http://regexlib.com/Search.aspx?k=email
const emailRegex = /^\S+@\S+\.\S+$/; // Of the form x@y.z

const hasInvalidChars = email => {
  if (!email || !email.match) {
    return true;
  }
  if (email.match(emailRegex)) {
    return false;
  }
  return true;
};
const isValidLength = email => {
  if (!email || email.length === 0 || email.length < MIN_EMAIL_LEN) {
    return false;
  }
  return true;
};

/**
 * Validates an email input field.
 * Should be of the form 'x@y.z'
 * TODO: Stricter character limits?
 */
const EmailValidator = {
  isEmailValid: email => {
    if (hasInvalidChars(email)) {
      return false;
    }
    if (!isValidLength(email)) {
      return false;
    }
    return true;
  },
  // Returns an appropriate message key from the emailMessages Translation Group explaining invalidity, or undefined if valid.
  getValidityMessageKey: email => {
    if (!isValidLength(email)) {
      return 'emailInputInvalidLengthWarning';
    }
    if (hasInvalidChars(email)) {
      return 'emailInputInvalidCharacters';
    }
    return undefined;
  },
  isEmailEmpty: email => {
    if (!email || email === '' || email.trim() === '') return true;
    return false;
  },
};

export default EmailValidator;
